var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:[
  'TreeNodeSwitcher', 
   !_vm.visible && 'isLeaf',
   _vm.switcherIcon, 
   _vm.expanded && 'expanded',
   ],style:(_vm.outerStyle),on:{"click":function($event){$event.stopPropagation();return _vm.$emit('expand',!_vm.expanded)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }